export default "__VITE_ASSET__C9KrtTM5__"